'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CharacterCount;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/CharacterCount.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CharacterCount(_ref) {
  var count = _ref.count,
      limit = _ref.limit,
      _ref$screenReaderOnly = _ref.screenReaderOnly,
      screenReaderOnly = _ref$screenReaderOnly === undefined ? false : _ref$screenReaderOnly;

  var srOnlyClass = screenReaderOnly ? 'sr-only' : '';
  var overLimitClass = count > limit ? 'over-limit' : '';
  var totalText = _react2.default.createElement(
    'span',
    { className: '' + overLimitClass },
    count
  );
  return _react2.default.createElement(
    'small',
    {
      className: srOnlyClass + ' cp-character-count' },
    _react2.default.createElement(
      'div',
      { 'aria-hidden': 'true', 'data-test-id': 'character-count-characters-used' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fraction_of_characters_used', values: { total: totalText, limit: limit } })
    ),
    _react2.default.createElement(
      _baseScreenReaderMessage2.default,
      null,
      _react2.default.createElement(
        _reactIntl.FormattedMessage,
        { id: 'fraction_of_characters_used_screen_reader', values: { total: count, limit: limit } },
        function (message) {
          return _react2.default.createElement(
            'div',
            { 'aria-live': 'polite', 'aria-atomic': 'true' },
            message
          );
        }
      )
    )
  );
}

CharacterCount.propTypes = {
  count: _react.PropTypes.number,
  limit: _react.PropTypes.number,
  screenReaderOnly: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-character-count/lib/components/CharacterCount.component.js
// module id = 886
// module chunks = 0 3